// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zFGxu","footnote":"styles_footnote__yzpzJ","grayText":"styles_grayText__Mbm-3","tableWrapper":"styles_tableWrapper__IKOnh"};